import penLogo from "../../../../assets/assocation_images/pen_logo.png";
import infoBackgroundImage from "../../../../assets/images/Background/Info_background.png";
import gyeongwon_middle_logo from "../../../../assets/assocation_images/gyeongwon_middle_logo.png";
import hyu_erica_logo from "../../../../assets/assocation_images/hyu_erica_logo.png";
import hyu_erica_BackgroundImage from "../../../../assets/assocation_images/hyu_erica_background.jpg";
import chereville_background from "../../../../assets/assocation_images/chereville_background.png";

const organizationList = {
    "PEN": { // 부산교육청
        logo: penLogo,
        backgroundImage: infoBackgroundImage
    },
    "GYEONGWON_MIDDLE": { // 경원중
        logo: gyeongwon_middle_logo,
        backgroundImage: null // 경원중은 배경이미지 없음
    },
    "HYU_ERICA": { // 한양대학교 에리카
        logo: hyu_erica_logo,
        backgroundImage: hyu_erica_BackgroundImage
    },
    "CHEREVILLE": { // 모던 쉐르빌
        logo: null,
        backgroundImage: chereville_background
    },
    "DEFAULT": { // 기본값
        logo: null,
        backgroundImage: infoBackgroundImage
    }
}

export const AtomGetLogo = (organization_type) => {
    if (organization_type === null || organization_type === undefined || !organizationList[organization_type]) {
        return [organizationList["DEFAULT"].logo, organizationList["DEFAULT"].backgroundImage];
    }
    return [organizationList[organization_type].logo, organizationList[organization_type].backgroundImage];
}